"use client";

import {
  useMutation,
  useQueryClient,
  type UseMutationResult,
} from "@tanstack/react-query";

import {
  createAutomationsSetupIntent,
  saveAutomationsPaymentMethod,
} from "../../client/manager/automations";
import { invalidateAutomations } from "./automationsInvalidation";

export function useCreateAutomationsSetupIntent(
  artistId: string
): UseMutationResult<string, Error, void> {
  return useMutation({
    mutationFn: () => createAutomationsSetupIntent(artistId),
  });
}

/** Saving a card refreshes the plan (past due may clear) and the Billing page. */
export function useSaveAutomationsCard(
  artistId: string
): UseMutationResult<{ retriedInvoiceDate: string | null }, Error, string> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (setupIntentId: string) =>
      saveAutomationsPaymentMethod(artistId, setupIntentId),
    onSettled: () =>
      invalidateAutomations(queryClient, {
        artistId,
        scope: ["entitlement", "billing"],
      }),
  });
}
